import { AxiosError } from "axios";

export interface ProblemDetails {
  errors: { [key: string]: any };
  type: string;
  title: string;
  status: number;
  traceId: string;
}

export function tryConvertToProblemDetails(error: any): ProblemDetails | any {
  if (error instanceof AxiosError) {
    const axoisError = error as AxiosError;
    if (
      !!(axoisError.response?.data as any).title &&
      !!(axoisError.response?.data as any).errors
    ) {
      return (error as AxiosError).response?.data;
    }
  }

  return error;
}
